import React from 'react';
import ChatInterface from '../features/chat/views/ChatInterface';
import Page from '../components/Page';

const Chatbot = () => {
  return (
    <Page width="default" safeArea="none" className="chatbot-page">
      <ChatInterface />
    </Page>
  );
};

export default Chatbot;
